import React from "react"
import {Swiper, SwiperSlide} from 'swiper/react';
import {domToReact} from "html-react-parser";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export const RenderedSwiper = ({node, options}) => {
  const getSetting = (dataAttribute, convert) => {
    return node.attribs[dataAttribute] ? convert(node.attribs[dataAttribute]) : undefined
  }

  const children = domToReact(node.children, options)?.filter(child => typeof child !== "string" || child.trim().replaceAll("\n", "") !== "")

  console.log("A", {
    autoplay: getSetting('data-autoplay-delay', parseInt)
  })

  return <>
    <Swiper
      spaceBetween={getSetting('data-space-between', parseInt)}
      slidesPerView={getSetting('data-slides-per-view', parseInt)}
      loop={getSetting('data-loop', (x) => x === 'true')}
      navigation={getSetting('data-navigation', (x) => x === 'true')}
      autoplay={{
        delay: getSetting('data-autoplay-delay', parseInt),
        disableOnInteraction: getSetting('data-autoplay-disable-on-interaction', (x) => x === 'true')
      }}
      pagination={{clickable: getSetting('data-pagination-clickable', (x) => x === 'true')}}
      scrollbar={{draggable: getSetting('data-scrollbar-draggable', (x) => x === 'true')}}
      modules={[Autoplay, Pagination, Navigation]}
    >

      {children.map(child => {
        return <SwiperSlide>{child}</SwiperSlide>
      })}
    </Swiper>
  </>
}